var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "75px",
    height: "58px",
    viewBox: "0 0 75 58",
    style: {
      enableBackground: "new 0 0 75 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#393939;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.8,49.9c0,1.6-0.4,3.4-1.4,4.4l3.1,3.1c2-2,2.6-4.4,2.6-7.5c0-4.1-2.2-7.6-6.2-7.6h1.6c2,0,4.4-1.3,4.4-4.6 v-2.4h-2.8c0.6-0.2,1.2-0.6,1.7-1.1c0.8-0.8,1.3-1.9,1.3-3.3c0-1.2-0.5-2.5-1.4-3.5H55V23H40.1v4.5H49c1.7,0,2,1.2,2,1.8 c0,0.6-0.3,1.8-2,1.8h-8.9v4.5h9.5c0.5,0,1,0,1.5-0.1v1.3c0,0.6-0.3,0.9-0.9,0.9H37.7v-7h0v-7.7H13.6v7.7h22.3l-12,6.2 c-1.3-2.6-4.2-5.4-8.7-5.4c-5.5,0-10.7,4-10.7,11.4v13.2h33.3v-0.9c1,0.8,2.2,1.2,3.6,1.2c1.7,0,3-0.4,3.9-1.4 c0.9-0.9,1.5-2.2,1.7-3.9l0.3-2.4c0.1-0.6,0.3-1,0.5-1.3c0.3-0.3,0.7-0.4,1.2-0.4C50.2,47.1,50.8,48,50.8,49.9z M11.8,48v-4.6 c0-2.2,1.6-3.6,3.4-3.6c1.7,0,3.4,1.3,3.4,3.6V48H11.8z M43,47.7l-0.3,2.4c-0.1,0.7-0.3,1.1-0.6,1.4c-0.3,0.3-0.7,0.4-0.9,0.4 c-0.9,0-1.8-0.7-1.8-2.4c0-0.9-0.1-2.5,1.2-3.7l-3-3c-1.4,1.4-2.1,3.2-2.3,5.4h-9.9v-2.8l10-4.7v1.8h13.6c-1.8,0-3.3,0.4-4.3,1.5 C43.8,44.7,43.3,45.9,43,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,1.5h-9.5c-1.6,0-3,0.4-4.3,1.6C40.4,3.9,40,5.3,40,6.7c0,1.7,0.4,2.9,1.6,4.2c-1.1,1-1.6,2.2-1.6,3.6 c0,1.2,0.5,2.5,1.4,3.5h-1.2v4.4H55v-4.5h-8.9c-1.7,0-2-1.2-2-1.8c0-0.6,0.3-1.8,2-1.8H55V9.6h-8.9c-1.7,0-2-1.2-2-1.8 c0-0.6,0.3-1.8,2-1.8H55V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.8,19.3c1.6-1.5,3.2-4,3.2-8.1s-1.6-6.6-3.2-8.1c-2.3-2.1-4.7-2.8-9.6-2.8c-4.9,0-7.3,0.7-9.6,2.8 c-1.6,1.5-3.2,4-3.2,8.1s1.6,6.6,3.2,8.1c2.3,2.1,4.7,2.8,9.6,2.8C30.1,22,32.5,21.4,34.8,19.3z M19.9,13.2 c-0.5-0.5-0.7-1.1-0.7-2.1c0-0.9,0.2-1.6,0.7-2.1c1-1,2.8-1.1,5.2-1.1c2.5,0,4.3,0.1,5.2,1.1c0.5,0.5,0.7,1.1,0.7,2.1 c0,0.9-0.2,1.6-0.7,2.1c-1,1-2.8,1.1-5.2,1.1C22.7,14.3,20.9,14.2,19.9,13.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 6.6,
    cy: 26.7,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.5,6.8c0-0.7,0-2,1.1-3.1l-2.5-2.5c-1.7,1.7-1.8,3.6-1.8,5.5c0,3,1.3,5.5,4.3,5.5c2,0,3.6-1.2,3.9-3.8 l0.2-2c0.1-0.9,0.6-0.8,0.7-0.8c0.3,0,0.7,0.3,0.7,1.3c0,1-0.1,2.1-0.8,2.7l1.8,1.8h-1.4v1.2h-5.5c-1.7,0-3.8,1.1-3.8,3.9v1.9h3.3 v-1.2c0-0.5,0.3-0.8,0.8-0.8h5.2v2h3v-2h3.6v-3.9h-3.6v-1.2h-0.4c0.8-1.2,1-2.6,1-4.4c0-2.5-1.4-5.1-4.2-5.1 c-2.5,0-3.5,1.5-3.7,3.7l-0.2,2c-0.1,0.8-0.4,0.9-0.8,0.9C59.7,8.4,59.5,7.3,59.5,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,22.9c0,1,0.4,2.2,1.2,3h-1v3.8h12.7v-3.9h-7.6c-1.5,0-1.7-1-1.7-1.6c0-0.5,0.3-1.6,1.7-1.6h7.6v-3.9 h-8.1c-1.3,0-2.5,0.2-3.6,1.3C56.6,20.7,56.2,21.7,56.2,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.4,31.4c-0.7,0.7-1.2,1.9-1.2,3.1c0,1.3,0.4,2.1,1.2,2.9h-1v3.8h16.8v-3.9h-5c0.7-0.7,1.1-1.6,1.1-2.8 c0-1.2-0.4-2.3-1.2-3.1c-1.3-1.3-3.5-1.2-5.3-1.2C60.8,30.2,58.6,30.1,57.4,31.4z M65.7,35.7c0,1.4-1.2,1.6-3,1.6 c-1.8,0-3-0.2-3-1.6c0-1.4,1.2-1.6,3-1.6C64.6,34.1,65.7,34.2,65.7,35.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 42.2,
    className: "st0",
    width: 3,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 42.2,
    className: "st0",
    width: 12.2,
    height: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,52.1c0,2.1,0.8,3.3,1.6,4.1c1.2,1.1,2.4,1.4,4.9,1.4c2.5,0,3.7-0.3,4.9-1.4c0.8-0.8,1.6-2,1.6-4.1 s-0.8-3.3-1.6-4.1c-1.2-1.1-2.4-1.4-4.9-1.4c-2.5,0-3.7,0.3-4.9,1.4C57,48.8,56.2,50.1,56.2,52.1z M65.4,51.1 c0.2,0.2,0.4,0.6,0.4,1c0,0.5-0.1,0.8-0.4,1c-0.5,0.5-1.4,0.6-2.6,0.6s-2.1-0.1-2.6-0.6c-0.2-0.2-0.4-0.6-0.4-1 c0-0.5,0.1-0.8,0.4-1c0.5-0.5,1.4-0.6,2.6-0.6S64.9,50.6,65.4,51.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBrand);
export default __webpack_public_path__ + "static/media/header_brand.0f6493f5828acf5737a1f3b27ec4760a.svg";
export { ForwardRef as ReactComponent };